import type { StudioProject } from "./types";

const now = new Date().toISOString();

export const sampleProject: StudioProject = {
  id: "blackred-commerce-demo",
  name: "BlackRed Commerce",
  slug: "blackred-commerce",
  description:
    "Experiencia ecommerce premium construida localmente con componentes, datos y workflows conectados.",
  version: "0.2.0",
  createdAt: now,
  updatedAt: now,
  theme: {
    primary: "#ff3d56",
    secondary: "#7c3aed",
    background: "#08080a",
    surface: "#141418",
    text: "#f7f7f8",
    muted: "#a1a1aa",
    radius: 18,
    font: "Manrope",
  },
  components: [
    {
      id: "navbar-1",
      kind: "navbar",
      name: "Navegación principal",
      title: "BLACKRED",
      body: "Colecciones|Novedades|Nosotros",
      actionLabel: "Explorar",
      tone: "dark",
    },
    {
      id: "hero-1",
      kind: "hero",
      name: "Portada",
      title: "Objetos que hacen inolvidable lo cotidiano.",
      body:
        "Una colección precisa, expresiva y creada para quienes valoran el diseño con intención.",
      actionLabel: "Descubrir colección",
      alignment: "left",
      tone: "accent",
    },
    {
      id: "stats-1",
      kind: "stats",
      name: "Indicadores",
      title: "Diseñado para durar",
      body: "24h Envío|30 días Garantía|100% Pago seguro",
      tone: "dark",
      columns: 3,
    },
    {
      id: "cards-1",
      kind: "cards",
      name: "Colecciones",
      title: "Selección de temporada",
      body:
        "Forma esencial|Edición nocturna|Materia viva|Líneas de estudio|Objetos de autor|Favoritos BlackRed",
      actionLabel: "Ver detalle",
      tone: "default",
      columns: 3,
    },
    {
      id: "form-1",
      kind: "form",
      name: "Registro",
      title: "Acceso anticipado",
      body:
        "Recibe lanzamientos, piezas limitadas y notas del estudio antes que nadie.",
      actionLabel: "Unirme",
      tone: "muted",
    },
    {
      id: "footer-1",
      kind: "footer",
      name: "Pie de página",
      title: "BLACKRED",
      body: "Hecho con intención. Construido con BlackRed Studio.",
      tone: "dark",
    },
  ],
  tables: [
    {
      id: "table-products",
      name: "products",
      label: "Productos",
      fields: [
        {
          id: "products-id",
          name: "id",
          type: "integer",
          required: true,
          primary: true,
        },
        {
          id: "products-name",
          name: "name",
          type: "text",
          required: true,
        },
        {
          id: "products-price",
          name: "price",
          type: "decimal",
          required: true,
        },
        {
          id: "products-active",
          name: "active",
          type: "boolean",
          required: true,
        },
      ],
    },
    {
      id: "table-orders",
      name: "orders",
      label: "Pedidos",
      fields: [
        {
          id: "orders-id",
          name: "id",
          type: "integer",
          required: true,
          primary: true,
        },
        {
          id: "orders-email",
          name: "customer_email",
          type: "text",
          required: true,
        },
        {
          id: "orders-total",
          name: "total",
          type: "decimal",
          required: true,
        },
        {
          id: "orders-created",
          name: "created_at",
          type: "date",
          required: true,
        },
      ],
    },
  ],
  workflows: [
    {
      id: "workflow-products-list",
      name: "Listar productos",
      method: "GET",
      route: "/api/products",
      actions: [
        {
          id: "products-input",
          kind: "input",
          label: "Leer filtros",
          detail: "q, category, page",
          enabled: true,
        },
        {
          id: "products-validate",
          kind: "validate",
          label: "Validar paginación",
          detail: "page >= 1",
          enabled: true,
        },
        {
          id: "products-query",
          kind: "query",
          label: "Consultar productos",
          detail: "products WHERE active = true",
          enabled: true,
        },
        {
          id: "products-response",
          kind: "response",
          label: "Responder JSON",
          detail: "{ data, total, page }",
          enabled: true,
        },
      ],
    },
    {
      id: "workflow-orders-create",
      name: "Crear pedido",
      method: "POST",
      route: "/api/orders",
      actions: [
        {
          id: "orders-input",
          kind: "input",
          label: "Recibir pedido",
          detail: "email, items, totals",
          enabled: true,
        },
        {
          id: "orders-validate",
          kind: "validate",
          label: "Validar inventario",
          detail: "Todos los productos disponibles",
          enabled: true,
        },
        {
          id: "orders-transform",
          kind: "transform",
          label: "Calcular totales",
          detail: "subtotal + impuestos + envío",
          enabled: true,
        },
        {
          id: "orders-query",
          kind: "query",
          label: "Guardar pedido",
          detail: "INSERT orders + order_items",
          enabled: true,
        },
        {
          id: "orders-response",
          kind: "response",
          label: "Confirmar pedido",
          detail: "{ orderId, status }",
          enabled: true,
        },
      ],
    },
  ],
  customCode: {
    html: "",
    css: "",
    javascript: "",
    detached: false,
  },
  activity: [
    {
      id: "activity-1",
      action: "Proyecto creado",
      detail: "Plantilla Commerce Studio",
      timestamp: now,
      status: "success",
    },
    {
      id: "activity-2",
      action: "Contrato de datos",
      detail: "2 tablas y 8 campos validados",
      timestamp: now,
      status: "info",
    },
    {
      id: "activity-3",
      action: "Workflows listos",
      detail: "2 endpoints conectados",
      timestamp: now,
      status: "success",
    },
  ],
};
